import React from 'react';
import Reflux from 'reflux';
import FormItemConst from '../../formItem/FormItemConst';
import Fade from '../../utils/Fade';
import {DiaLogMapEditorsStore} from '../../stores/CommandStore';
import DialogValue from './remote/DialogValue';
import FormItemTimeResolver from '../../formItem/resolver/FormItemTimeResolver';

export default class DialogFieldTimeEditor extends React.Component
{
    constructor(props)
	{
		super(props);
		this.initMembers();
		this.state = {data:this.props.data};
		this.unsubscribeDiaLogMapEditorsStore = DiaLogMapEditorsStore.listen(this.onDiaLogMapEditors.bind(this));
	}

	initMembers()
	{
		
		this.lookupEvents = [
			[$(document), {
				'mousedown touchstart': $.proxy(function(e){
					console.log("执行到了注册的事件侦听 是否已卸载");					
					if (!(
						$(this.inputFieldContainer).is(e.target) ||
						$(this.inputFieldContainer).find(e.target).length ||
						this.dropdownform.is(e.target) ||
						this.dropdownform.find(e.target).length
					)){
						this.closeDropDown();
					}
				}, this)
			}]
		];
		
	}

	onDiaLogMapEditors(dialogId,result)
	{
		if(this.props.dialogId == dialogId)
		{
			let dv = new DialogValue();
			dv.id = this.props.data.id;dv.editorType = this.props.data.editorType;
			dv.value = $(this.inputField).val();dv.entityId = this.props.data.entityId;
			//alert("DialogFieldStringEditor侦听");
			result[this.props.data.id] = dv;
		}
	}


	componentWillUnmount()
	{
		this.unsubscribeDiaLogMapEditorsStore();
	}

	inputFieldBlur()
	{
		let value = $(this.inputField).val();
		if(!value)
			return;
		let newValue = FormItemTimeResolver.getResult(value,false);
		if(newValue.indexOf("false:") == 0)
		{
			$(this.inputField).val("00:00:00");
			Fade.show({text:newValue.substr(6)});
			return;
		}
		$(this.inputField).val(newValue);
	}

	onKeyDownHandler(e)
	{
		if(e.keyCode>64&&e.keyCode<91)
		{
			e.preventDefault();
		}
	}

	
	getInputDom(_width)
	{
		let allowEdit = this.state.data.allowEdit;
		let _id = this.state.data.id;
		let _defaultValue = this.state.data.defaultValue;
		if(!_defaultValue)
			_defaultValue = "";
		if(allowEdit)
		{
			let _style = {padding:'2px',height:FormItemConst.EDITOR_HEIGHT+'px',width:_width,fontSize:"12px"}
			
			return	<input spellCheck="false" ref={node => this.inputField = node} type="text" 
			        	   className="form-control" style={_style} defaultValue={_defaultValue}
						   onBlur={this.inputFieldBlur.bind(this)}  onKeyDown={this.onKeyDownHandler.bind(this)}/>;
		}
		else
		{	
			let _style = {padding:'2px',height:FormItemConst.EDITOR_HEIGHT+'px',width:_width,backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR,fontSize:"12px"};		
			
			return	<input spellCheck="false" ref={node => this.inputField = node} type="text" readOnly="readonly"
			        	   className="form-control" style={_style} defaultValue={_defaultValue}
						   onBlur={this.inputFieldBlur.bind(this)}  onKeyDown={this.onKeyDownHandler.bind(this)}/>;
		}
	}

	getDropDownHtml()
	{
		return $('<div class="dateTimeWrap" style="padding-top:0px;background: #FFFFFF;border: 1px solid #CDCDCD;box-shadow: 0 2px 6px 0 rgba(0,0,0,0.14);border-radius: 2px;display: block;height: 240px; width: 180px;z-index: 6666;"><div class="timePart" style=""><ul style="display:flex;padding-left: 0px;border-top:none;margin-bottom:7px"><li id="selHour"><p>时</p><ol style="border-right:none;"><li class="cur">00</li><li>01</li><li>02</li><li>03</li><li>04</li><li>05</li><li>06</li><li>07</li><li>08</li><li>09</li><li>10</li><li>11</li><li>12</li><li>13</li><li>14</li><li>15</li><li>16</li><li>17</li><li>18</li><li>19</li><li>20</li><li>21</li><li>22</li><li>23</li></ol></li><li id="selMinute"><p>分</p><ol><li class="cur">00</li><li>01</li><li>02</li><li>03</li><li>04</li><li>05</li><li>06</li><li>07</li><li>08</li><li>09</li><li>10</li><li>11</li><li>12</li><li>13</li><li>14</li><li>15</li><li>16</li><li>17</li><li>18</li><li>19</li><li>20</li><li>21</li><li>22</li><li>23</li><li>24</li><li>25</li><li>26</li><li>27</li><li>28</li><li>29</li><li>30</li><li>31</li><li>32</li><li>33</li><li>34</li><li>35</li><li>36</li><li>37</li><li>38</li><li>39</li><li>40</li><li>41</li><li>42</li><li>43</li><li>44</li><li>45</li><li>46</li><li>47</li><li>48</li><li>49</li><li>50</li><li>51</li><li>52</li><li>53</li><li>54</li><li>55</li><li>56</li><li>57</li><li>58</li><li>59</li></ol></li></ul><div class="timeFooter"><span id="ensure">确定</span><span id="curTime">当前时间</span></div></div></div>');
	}

	getDownArrowButtonDom()
	{
		let allowEdit = this.state.data.allowEdit;
		if(allowEdit)
		{
			return <i ref={node => this.downArrowButton = node} onClick={this.showDropDown.bind(this)} className="fa fa-clock-o" style={{position:'absolute',top:'calc(100% / 2 - 5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>;
		}
		else
		{
			return <i ref={node => this.downArrowButton = node} className="fa fa-clock-o" style={{position:'absolute',top:'calc(100% / 2 - 5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>
		}
	}

	closeDropDown()
	{
		if(this.dropDownShowed)
		{

			let lookupdiv = this.dropdownform;
			if(lookupdiv == null)
				return;
			this.detachEventListeners();
			
			lookupdiv.remove();
			this.dropDownShowed = false;
			this.dropdownform = null;
			this.focusByCloseDropDrown = true;
			this.inputField.focus();
			this.inputField.select();
			return false;	
		}

	}

	showDropDown()
	{
		if(this.dropDownShowed == true)
		{
			this.closeDropDown();
			return;
		}
		let $dropdown = this.getDropDownHtml();
		$('body').append($dropdown);

		let nowVal = $(this.inputField).val();
		if(nowVal && typeof(nowVal) == "string")
		{
			let hourLis = $(".dateTimeWrap #selHour>ol>li");
			let minuteList = $(".dateTimeWrap #selMinute>ol>li");
			let _arr = nowVal.split(":");
			let nowHour = _arr[0];let nowMinute = _arr[1];
			for(let i = 0;i<hourLis.length;i++)
			{
				let item = hourLis[i];
				if($(item).html() == nowHour)
				{
					hourLis.removeClass("cur");
					$(item).addClass("cur");
					$(item).parent().scrollTop($(item).offset().top - $(item).height());
					break;
				}
			}

			for(let k = 0;k<minuteList.length;k++)
			{
				let item = minuteList[k];
				if($(item).html() == nowMinute)
				{
					minuteList.removeClass("cur");
					$(item).addClass("cur");
					$(item).parent().scrollTop($(item).offset().top - $(item).height());
					break;
				}
			}
		}
		

		this.dropdownform = $dropdown;
		var lookupdiv = $dropdown;
		var _inputwidth = $(this.inputField).width();//this.props.displayLengthWidth;
		var _iframewidth = lookupdiv.outerWidth();
		
		var _iframeheight = lookupdiv.outerHeight();
		
		var _gwidth = $("#app").width();
		var _gheight = $("#app").height();

		if(_iframewidth>_gwidth)
		{
			_iframewidth = _gwidth;
			lookupdiv.css({width:_iframewidth+'px',overflow:"auto"});
		}
		var _offset = $(this.inputField).offset();
		var _y = _offset.top; 
		var _x = _offset.left;
		var _top = _y+$(this.inputField).height()+5;
		//alert('x:'+_x+'y:'+_y);
		//下方屏幕放不下
		if((_top+_iframeheight)>_gheight)
		{
			//上下都放不下 考虑缩减高度
			if(_iframeheight>_y)
			{
				//上方空间大
				if(_y>(_gheight/2))
				{
					lookupdiv.height(_y-2);
					_top = '0px';
				}
				else //下方空间大
				{
					lookupdiv.css("height",(_gheight-_top)+'px');	
				}
			}
			else//下拉框置于上方
			{
				_top = (_y-_iframeheight)+'px';
			}
		}
		var _left = _x-((_iframewidth-_inputwidth)/2);
			//(_iframewidth-_inputwidth)/2;
		if(_left+_iframewidth>_gwidth)
			_left = _gwidth-_iframewidth-5;
		if(_left<0)_left = 0;
		
		lookupdiv.css({left:(_left+'px'),top:_top});
		this.dropDownShowed = true;
		this.attachEventListeners();
	}

	attachEventListeners()
	{
		this.unapplyEvents(this.lookupEvents);
		this.applyEvents(this.lookupEvents);

		this.dropdownform.find("ul>li>ol>li").on("click",this.timeLiClickHandler.bind(this));
		this.dropdownform.find("#ensure").on("click",this.timeEnsureHandler.bind(this));
		this.dropdownform.find("#curTime").on("click",this.timeNowEnsureHandler.bind(this));
	}

	detachEventListeners()
	{
		this.unapplyEvents(this.lookupEvents);
		this.dropdownform.find("ul>li>ol>li").off();
		this.dropdownform.find("#ensure").off();
		this.dropdownform.find("#curTime").off();
	}

	timeLiClickHandler(e)
	{
		$(e.target).parent().find("li").removeClass("cur");
		$(e.target).addClass("cur");
	}

	timeEnsureHandler(e)
	{
		let selectedLi = this.dropdownform.find("li.cur");
		let timeStr = "";
		for(let i = 0;i<selectedLi.length;i++)
		{
			let li = $(selectedLi[i]);
			timeStr = timeStr + li.text() + ":";
		}
		timeStr+="00";
		$(this.inputField).val(timeStr);
		this.closeDropDown();
	}

	timeNowEnsureHandler(e)
	{
		let _date = new Date();
       
		var hours = _date.getHours();
		if(hours<10)
			hours = "0"+hours;
		var minutes = _date.getMinutes();
		if(minutes<10)
			minutes = "0"+minutes;
		var seconds =_date.getSeconds();
		if(seconds<10)
			seconds = "0"+seconds;
		let timeStr = hours+":"+minutes+":"+seconds;
		$(this.inputField).val(timeStr);
		this.closeDropDown();
	}

	applyEvents(evs)
	{
		for (var i=0, el, ch, ev; i < evs.length; i++)
		{
			el = evs[i][0];
			if (evs[i].length === 2){
				ch = undefined;
				ev = evs[i][1];
			}
			else if (evs[i].length === 3){
				ch = evs[i][1];
				ev = evs[i][2];
			}
			el.on(ev, ch);
		}
	}

	unapplyEvents(evs)
	{
		for (var i=0, el, ev, ch; i < evs.length; i++)
		{
			el = evs[i][0];
			if (evs[i].length === 2){
				ch = undefined;
				ev = evs[i][1];
			}
			else if (evs[i].length === 3){
				ch = evs[i][1];
				ev = evs[i][2];
			}
			el.off(ev, ch);
		}
	}


	render()
	{
		let displayLength=this.state.data.displayLength;
		if(displayLength == 0)displayLength = FormItemConst.DISPLAYLENGTH_DATE_DEFAULT;
        let _width=displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon+'px';
        let notNull=this.state.data.notNull;
		let _label = this.state.data.label;
		let _id = this.state.data.id;

		var _notNullStyle={};
		_notNullStyle['fontSize']='8px';
    	_notNullStyle['color']='red';
		if(!notNull)
			_notNullStyle['visibility']='hidden';
		
		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'center'};
		
		let inputdom = this.getInputDom(_width);
        let labelStyle = {paddingLeft:'5px',width:'auto',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'};
        let dropDownButton = this.getDownArrowButtonDom();
		return(

			<div id={"EditorDialog"+_id} className='editorGroup' style={editorStyle}>
				<label htmlFor={"inputDialog"+_id} className="fieldGroupLabel" ref={node => this.componentLabel = node} style={labelStyle}>
					{_label}
				</label>
				<i className='fa fa-snowflake-o' style={_notNullStyle}></i>
				<div style={{position:"relative"}}>
					{inputdom}{dropDownButton}
			    </div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/dialog/DialogFieldTimeEditor.js